import React from 'react'
import DesktopRelatedTravelItems from '../RelatedTravelItems/DesktopRelatedTravelItems'
import Group from 'components/utils/Group'
import useShareModalConfig from 'hooks/useShareModalConfig'
import ShareModal from 'components/Common/Modals/ShareModal'
import ShareWithFriendsButton from 'components/Common/ShareWithFriendsButton'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import styled from 'styled-components'
import { rem } from 'polished'
import { TopMobileRelatedTravelItems } from '../RelatedTravelItems'
import { useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const Header = styled(Pane)`
  height: ${rem(62)};
  display: flex;
  align-items: center;
`

interface Props {
  offer: App.Offer;
}

function VillasPageHeader(props: Props) {
  const { offer } = props

  const shareConfig = useShareModalConfig({
    type: 'offer',
    offerId: offer.id,
    image: offer.images[0],
    location: [offer.locationHeading, offer.locationSubheading].filter(t => t).join(', '),
    offerType: 'hotel',
  })

  const travelItems = useAppSelector(state => state.offer.relatedTravelItems[offer.id]) ?? EmptyArray

  return <Header>
    <LayoutContainer>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center" gap={0} tabletGap={40}>
        <DesktopRelatedTravelItems offer={offer} />
        <TopMobileRelatedTravelItems items={travelItems} />
        <CSSBreakpoint min="tablet">
          <Group direction="horizontal" gap={12} verticalAlign="center">
            <ShareModal shareConfig={shareConfig}>
              <ShareWithFriendsButton />
            </ShareModal>
            <BookmarkButton offer={offer} />
          </Group>
        </CSSBreakpoint>
      </Group>
    </LayoutContainer>
  </Header>
}

export default VillasPageHeader
